exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unit-leases-table tr[data-v-22726c11]{border-bottom:2px solid #434343}.data-table--row[data-v-22726c11]{grid-template-columns:65px 1fr 1fr 1fr 1fr 50px;font-size:14px}h4[data-v-22726c11]{color:#213a56;margin:0;margin-bottom:0;margin-top:35px}.data-table--body .data-table--item[data-v-22726c11]{-ms-flex-item-align:center;align-self:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22726c11","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/unit/UnitDetails.vue
// module id = Cd9A
// module chunks = 0 1